import React from "react";
import { Badge, Group, Skeleton, Text } from "@mantine/core";
import { Alert } from "@xplatform/design-system";
import { IconServer } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useAccessScope } from "@hooks/access";

/**
 * Which application and BeeHive every change on the page goes to, e.g.
 * "xplatform-sandbox · dev BeeHive", so nothing is changed in the wrong place.
 */
const EnvironmentBanner: React.FC = () => {
  const { t } = useTranslation();
  const scope = useAccessScope();

  if (scope.error) {
    return <Alert color={scope.forbidden ? "gray" : "red"} title={t("admin.access.scope.loadFailed")}>{scope.error}</Alert>;
  }
  if (!scope.data) return <Skeleton h={44} radius="sm" />;

  const { application, beehive, environment } = scope.data;
  return (
    <Alert color={beehive === "prod" ? "orange" : "blue"} icon={<IconServer size={18} />} py="xs">
      <Group gap="sm" wrap="wrap">
        <Text size="sm" fw={600} data-testid="access-environment">
          {t("admin.access.scope.banner", { application: application.code, beehive })}
        </Text>
        <Badge variant="light" color="gray" size="sm">{environment}</Badge>
        <Text size="xs" c="dimmed" ff="monospace">{application.id}</Text>
      </Group>
    </Alert>
  );
};

export default EnvironmentBanner;
